import { render, staticRenderFns } from "./HistoryComponent.vue?vue&type=template&id=75af7f20&scoped=true&"
import script from "./HistoryComponent.vue?vue&type=script&lang=js&"
export * from "./HistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75af7f20",
  null
  
)

export default component.exports